import { canonicalizeUrl } from './urlMatching.js';
const HANDOFF_KEYS = ['oq-verify-issue', 'oq-verify-job'];
/** Read only our handoff fields; the site's query and fragment remain intact. */
export function parseVerificationHandoff(input) {
    const url = new URL(input);
    const fields = new Map();
    for (const key of HANDOFF_KEYS) {
        const value = url.searchParams.get(key);
        if (value && /^[a-zA-Z0-9_-]+$/.test(value)) {
            fields.set(key, value);
            url.searchParams.delete(key);
        }
    }
    // Legacy handoffs live in the fragment. Remove exact fields only, never
    // erase a site's hash route or an anchor that happens to contain our name.
    const parts = url.hash.slice(1).split('&').filter(part => {
        const match = /^(oq-verify-issue|oq-verify-job)=([a-zA-Z0-9_-]+)$/.exec(part);
        if (!match)
            return true;
        if (!fields.has(match[1]))
            fields.set(match[1], match[2]);
        return false;
    });
    url.hash = parts.join('&');
    return {
        pageUrl: url.href,
        issueId: fields.get('oq-verify-issue') ?? null,
        jobId: fields.get('oq-verify-job') ?? null,
    };
}
/** Verification keeps state-bearing queries and ALL page fragments. */
export function verificationPageUrl(input) {
    const page = new URL(parseVerificationHandoff(input).pageUrl);
    const normalized = new URL(canonicalizeUrl(page.href));
    normalized.searchParams.sort();
    const base = canonicalizeUrl(normalized.href);
    return `${base}${page.hash}`;
}
export function verificationUrlsMatch(a, b) {
    try {
        return verificationPageUrl(a) === verificationPageUrl(b);
    }
    catch {
        return false;
    }
}
/** Preserve hash routing; hashless pages retain the existing handoff format. */
export function verificationHandoffUrl(input, kind, id) {
    const url = new URL(parseVerificationHandoff(input).pageUrl);
    if (!/^[a-zA-Z0-9_-]+$/.test(id))
        throw new Error('Invalid verification handoff id');
    if (url.hash) {
        url.searchParams.set(`oq-verify-${kind}`, id);
        return url.href;
    }
    // Preserve the longstanding spelling while replacing any prior handoff.
    const clean = parseVerificationHandoff(input);
    const base = clean.issueId || clean.jobId ? clean.pageUrl : input;
    return `${base}#oq-verify-${kind}=${id}`;
}
//# sourceMappingURL=verificationUrl.js.map